import React from 'react';
import './AboutUs.css'

const Aboutus = () => {
    return (
        <div>
            <h2>This is About Us Page</h2>
        </div>
    );
};

export default Aboutus;